// https://vuex.vuejs.org/en/mutations.html

import Vue from 'vue';

export default {

  setCurrentUser(state, userInfo) {
    state.userInfo = userInfo;
  },

  setCurrentUserLicenseData(state, licenseData) {
    state.licenseData = licenseData;
  },

  setCurrentUserPowerMode(state, powerMode) { 
    state.isCurrentUserPowerUser = powerMode;
  },

  setSnackInfo(state, snackInfo) {
    state.showSnack = true;
    state.snackColor = snackInfo.color;
    state.snackText = snackInfo.message;
  },

  setAdminUsersData(state, users) {
    state.adminUsersList = users;
  },

  setAdminUserData(state, payload) {
    let user_id = payload.id;
    let user_data = payload.data;
    let userToEdit = state.adminUsersList.find( el => el.sub_id == user_id);
    if( userToEdit != null ) {
      Vue.set(userToEdit, "licenses", user_data.licenses);
    }
  },

  setAvailableLidars(state, lidars) { 
    state.availableLidars = new Map([...lidars].sort((a, b) => a[1] > b[1] ? 1 : -1));
  },

  setAllowFeatures(state, features) { 
    state.allowFeaturesList = features;
  }
  
}
